/* eslint-disable no-unused-vars */
import React, { FunctionComponent } from 'react';

import { css } from '@emotion/react';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, FieldErrors } from 'react-hook-form';
import Select from 'react-select';

import { palette } from '@styles/theme';

interface OptionProps {
  label: string;
  value: string;
}

interface Props {
  options: OptionProps[];
  control: any;
  name: string;
  fieldName?: string;
  width?: number;
  rules: any;
  errors: FieldErrors;
  placeholder?: string;
  isLoading?: boolean;
  isSearchable?: boolean;
  noOptionsMessage?:
    | ((obj: { inputValue: string }) => React.ReactNode)
    | undefined;
  isMenuFixed?: boolean;
  handleChange?: any;
  isErrorText?: boolean;
  errorTextAlign?: 'left' | 'center' | 'right';
}

const SelectBox: FunctionComponent<Props> = ({
  options,
  placeholder,
  name,
  fieldName,
  width,
  control,
  rules,
  errors,
  isLoading = false,
  isSearchable = false,
  noOptionsMessage,
  isMenuFixed = false,
  handleChange,
  isErrorText = true,
  errorTextAlign = 'right',
}) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          return (
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                width: `${width ? `${width}px` : '100%'}`,
                padding: '6px 0',
              }}
            >
              <Select
                {...field}
                onChange={(e: any) => {
                  if (handleChange) {
                    handleChange(e, field.onChange);
                  } else {
                    field.onChange(e);
                  }
                }}
                options={options}
                placeholder={placeholder ?? '선택해 주세요'}
                isLoading={isLoading}
                isSearchable={isSearchable}
                noOptionsMessage={noOptionsMessage}
                components={{
                  IndicatorSeparator: () => null,
                }}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary: palette.primaryColor,
                  },
                })}
                menuPortalTarget={
                  !isMenuFixed ? document.querySelector('body') : undefined
                }
                menuPosition={isMenuFixed ? 'fixed' : undefined}
              />
              {isErrorText && errors[fieldName ? fieldName : name] && (
                <ErrorMessage
                  errors={errors}
                  name={name}
                  render={({ message }) => (
                    <p css={errorMessage(errorTextAlign)}>{message}</p>
                  )}
                />
              )}
            </div>
          );
        }}
      />
    </>
  );
};

export default SelectBox;

const errorMessage = (textAlign: 'left' | 'center' | 'right') => css`
  color: ${palette.colorDanger};
  font-size: 12px;
  padding: 3px 5px;
  height: 22px;
  text-align: ${textAlign};
`;
